import { initializeIntl, initializeLogging, initializeSession } from ".";
export default async function PromiseBootstrap() {
    const session = await initializeSession();
    const intl = await initializeIntl({ session });
    const logger = await initializeLogging({ session });
    return { logger, intl, session };
}
